import {
  OfferConditionTypeEnum,
  OfferDiscountTypeEnum,
  type OfferV11,
} from '@redteclab/api/clients/bully'

import { productAccessorGetSellerPromotionFromOffer } from './productAccessorGetSellerPromotionFromOffer'

export const productAccessorOfferHasFreeItemSellerPromotion = (
  offer: OfferV11 | undefined,
): boolean => {
  if (!offer) {
    return false
  }

  const sellerPromotion = productAccessorGetSellerPromotionFromOffer(offer)

  return (
    sellerPromotion?.conditionType ===
      OfferConditionTypeEnum.MinimumSameItemQuantity &&
    sellerPromotion.discountType === OfferDiscountTypeEnum.FreeItems
  )
}
